import Swal from 'sweetalert2';
import UtilsUrl from '../../utils/UtilsUrl';
import api from "./../api";

const addPost = (formData) => {
    return api.post(UtilsUrl.rhURL() + `/postes/add_post`, formData);
};
const getPostes = (idUser) => {
    return api.get(UtilsUrl.rhURL() + "/postes/" + idUser);
};
const updatePoste =  (formData) => {
    return api.post(UtilsUrl.rhURL() + "/postes/update_post/", formData);
};
const deletePoste = async (postID, setPosts) => {
    try {
        const result = await Swal.fire({
            title: 'Es-tu sûr?',
            text: 'Vous ne pourrez pas annuler cette action !',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, supprimez-le !',
            cancelButtonText: 'Non, annulez !',
            reverseButtons: true,
        });

        if (result.isConfirmed) {
            await api.put(UtilsUrl.rhURL() + `/postes/archive_post/${postID}`, { isDeleted: true });

            Swal.fire('Supprimé !', 'Le type de contrat supprimé avec succès.', 'success');

            setPosts((prevState) => prevState.filter((contracttype) => contracttype.id !== postID));
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire('Cancelled', 'Your file is safe :)', 'error');
        }
    } catch (error) {
        console.error(error);
    }
}
const checkNomPoste = (NomPoste, idUser) => {

    return api.get(UtilsUrl.rhURL() + "/postes/checkNomPost/" + NomPoste + "/" + idUser);

};
export { addPost, getPostes, updatePoste, deletePoste, checkNomPoste };